import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RevokeApiKeyMutationVariables = Types.Exact<{
  keyId: Types.Scalars['UUID']['input'];
}>;

export type RevokeApiKeyMutation = {
  __typename?: 'Mutation';
  revokeApiKey: boolean;
};

export const RevokeApiKeyDocument = gql`
  mutation RevokeApiKey($keyId: UUID!) {
    revokeApiKey(keyId: $keyId)
  }
`;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<
  RevokeApiKeyMutation,
  RevokeApiKeyMutationVariables
>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeApiKeyMutation,
    RevokeApiKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeApiKeyMutation,
    RevokeApiKeyMutationVariables
  >(RevokeApiKeyDocument, options);
}
export type RevokeApiKeyMutationHookResult = ReturnType<
  typeof useRevokeApiKeyMutation
>;
export type RevokeApiKeyMutationResult =
  Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<
  RevokeApiKeyMutation,
  RevokeApiKeyMutationVariables
>;
